// ======================================================================
// File Name       : ContentDocumentEditRegister
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Col, Form } from 'react-bootstrap';
import { DOC_ACCEPT_FILE, DOC_ACCEPT_TYPE } from '../../constants/ContentConstant';
import { VALIDATE_TYPE } from '../../constants/index';
import RenderField from '../../utils/ReduxFormUtils';

class ContentDocumentEditRegister extends Component {
  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }
  render() {
    const {
        contentSecernId,
        contentName,
        documentName,
        uploadFile,
        documentSize,
        isEdit,
    } = this.props;
    const validates = !isEdit ? [VALIDATE_TYPE.REQUIRED] : [];
    return (
      <div>
        <h3>登録する項目を指定してください</h3>
        <Form className="form-horizontal margin-top-10">
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={4}>
              コンテンツ識別ID
            </Col>
            <Col sm={7}>
              {isEdit && (
                <Col as={Form.Label} className="padding-left-clear">
                  {contentSecernId}
                </Col>
              )}
              {!isEdit && (
                <RenderField
                  type="text"
                  name="contentSecernId"
                  label="コンテンツ識別ID"
                  maxLength="64"
                  value={contentSecernId}
                  validates={[VALIDATE_TYPE.ID]}
                />
              )}
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={4}>
              コンテンツ名 <span className="required">&nbsp;(※)</span>
            </Col>
            <Col sm={7}>
              <RenderField
                type="text"
                name="contentName"
                label="コンテンツ名"
                validates={[VALIDATE_TYPE.REQUIRED]}
                value={contentName}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info flex-wrap">
            <Col as={Form.Label} sm={4}>
              ファイル選択
              {isEdit ? null : <span className="required">&nbsp;(※)</span>}
            </Col>
            <Col sm={7}>
              <RenderField
                type="batchimport"
                name="uploadFile"
                label="ファイル選択"
                validates={
                  isEdit
                    ? [VALIDATE_TYPE.DOCUMENT_SIZE, VALIDATE_TYPE.ACCEPT_FILE]
                    : [
                        VALIDATE_TYPE.REQUIRED,
                        VALIDATE_TYPE.DOCUMENT_SIZE,
                        VALIDATE_TYPE.ACCEPT_FILE,
                      ]
                }
                value={documentSize}
                fileName={documentName}
                fileSize={documentSize}
                fieldInput={8}
                fieldButton={4}
                accept={DOC_ACCEPT_TYPE}
                acceptCheck={DOC_ACCEPT_FILE}
                showMessageErrorFullRows
              />
            </Col>
            <Col as={Form.Label} sm={12}>
              ※利用可能なファイルの種類は、拡張子が「pdf」「zip」「pptx」「docx」のファイルのみとなります。
              <p className="padding-top-15">
                ※アップロードするファイルサイズの上限は200MBまでとなります。
              </p>
            </Col>
          </Form.Group>
        </Form>
      </div>
    );
  }
}

export default ContentDocumentEditRegister;
